var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "vl-map",
        {
          staticStyle: { height: "600px" },
          attrs: {
            "load-tiles-while-animating": true,
            "load-tiles-while-interacting": true,
            "data-projection": "EPSG:4326"
          }
        },
        [
          _c("vl-view", {
            attrs: {
              zoom: _vm.zoom,
              center: _vm.center,
              rotation: _vm.rotation
            },
            on: {
              "update:zoom": function($event) {
                _vm.zoom = $event
              },
              "update:center": function($event) {
                _vm.center = $event
              },
              "update:rotation": function($event) {
                _vm.rotation = $event
              }
            }
          }),
          _vm._v(" "),
          _c(
            "vl-geoloc",
            [
              [
                _c(
                  "vl-feature",
                  { attrs: { id: "position-feature" } },
                  [
                    _vm.location
                      ? _c("vl-geom-point", {
                          attrs: { coordinates: _vm.location }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "vl-style-box",
                      [
                        _c("vl-style-icon", {
                          attrs: {
                            src: "../../static/marker.png",
                            scale: 0.3,
                            anchor: [0.5, 1]
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "vl-layer-tile",
            { attrs: { id: "osm" } },
            [_c("vl-source-osm")],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticStyle: { padding: "20px" } }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$t("insert.customer.Model_Code")) +
            ": " +
            _vm._s(_vm.Location.Code)
        ),
        _c("br"),
        _vm._v(
          "\n    " +
            _vm._s(_vm.$t("insert.customer.Model_Location_Description1")) +
            ": " +
            _vm._s(_vm.Location.Description1)
        ),
        _c("br"),
        _vm._v(
          "\n    " +
            _vm._s(_vm.$t("insert.customer.Model_XPosition")) +
            " - " +
            _vm._s(_vm.$t("insert.customer.Model_YPosition")) +
            ": " +
            _vm._s(_vm.Location.XPosition) +
            " - " +
            _vm._s(_vm.Location.YPosition)
        ),
        _c("br"),
        _vm._v(
          "\n    " +
            _vm._s(_vm.$t("insert.warehouse.Address")) +
            ": " +
            _vm._s(_vm.Location.AddressDetail)
        ),
        _c("br")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9cd54810", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9cd54810","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NextLocation.vue
// module id = null
// module chunks = 